import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import FabButton from "../../../../partials/Buttons/FabButton";
import { ReadData } from "../../../../providers/Patient.Provider";
import NewObservation from "./NewObservation";
import { useQuery, useMutation } from "react-apollo";
import { GET_OBSERVATION, NEW_OBSERVATION } from "../../../../queries/observation.query";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import LoadingSpinner from "../../../../partials/loading";
import ObservationList from "./ObservationList";
import ObservationDetail from "./ObservationDetail";

function HealthObservation({ match }) {
    const [newItem, setNewItem] = useState(false);
    const [activeItem, setActiveItem] = useState(null);

    const title = "Health Observation";
    const { id } = match.params;
    const patient = ReadData();

    const { loading, data } = useQuery(GET_OBSERVATION, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        variables: { id },
    });

    const [createFunc, { loading: cLoading }] = useMutation(NEW_OBSERVATION, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message, doc } = d.NewHealthObservation;
            toast.success(message);
            setNewItem(false);
            setActiveItem(doc);
            scrollTop();
        },
        update: (cache, { data }) => {
            const { GetHealthObservations } = cache.readQuery({
                query: GET_OBSERVATION,
                variables: { id },
            });
            GetHealthObservations.docs.unshift(data.NewHealthObservation.doc);
            cache.writeQuery({
                query: GET_OBSERVATION,
                variables: { id },
                data: { GetHealthObservations },
            });
        },
    });

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                {!newItem && !activeItem && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>{title}</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "480px" }}>
                                <LoadingSpinner loading={loading} />
                                {data && (
                                    <ObservationList
                                        onView={(item) => {
                                            setActiveItem(item);
                                            scrollTop();
                                            setNewItem(false);
                                        }}
                                        items={data.GetHealthObservations.docs}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {newItem && !activeItem && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New Health Observation
                                </header>
                            </div>
                            <div className="card-body">
                                <NewObservation
                                    onCancel={() => {
                                        setNewItem(false);
                                        setActiveItem(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async (model) => {
                                        await createFunc({ variables: { model: { ...model, patient: id, admission: patient.lastAdmission } } });
                                    }}
                                />
                                <LoadingSpinner loading={cLoading} />
                            </div>
                        </div>
                    </div>
                )}

                {!newItem && activeItem && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewItem(false);
                                            setActiveItem(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Detail
                                </header>
                            </div>
                            <div className="card-body">
                                <ObservationDetail item={activeItem} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {!newItem && (
                <div className="fade-in">
                    <FabButton
                        onClick={() => {
                            scrollTop();
                            setNewItem(true);
                            setActiveItem(null);
                        }}
                        title={"New " + title}
                    />
                </div>
            )}
        </>
    );
}
export default HealthObservation;
